export interface SalesInvoiceForCreditNote {
  id: string;
  invoiceNo: number;
  dateInvoiced: Date;
  invoiceStatus: string;
  customerKey: string;
  customerName: string;
  currencyCode: string;
  nettTotal: string;
  deliveryTotal: string;
  extraTotal: string;
  taxRate: string;
  taxTotal: string;
  overallTotal: string;
  colour: string;
}
